Odigeo.defineWidget('checkout_root', Odigeo.RootComponent);
